import { DefaultService } from '@/services/DefaultService';

export default class ExportacaoDadosService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    
    // Aqui já faz o update também, caso seja passado o id da exportacao o metodo identifica que é um update e atualiza os seguintes campos:
    // url = ?, datahoradisponivel = ?, datahoraexcluido = ?, situacao = ?
    /*Multi = inteiro. 0 = false, 1 = true; Usado para definir se é exportado uma lista ou apenas um registro.*/
    saveAtendimentoOld(exportacaoatendimentos, multiple, tipo) {
        return this._http.post(`${this._env}/exportadados/atendimento/${tipo}?multiple=${multiple}`, (exportacaoatendimentos), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao salvar a exportação');
        });
    }

    saveAtendimento(exportacao, tipo, uuid, isTemp = false) {
        return this._http.post(
            `${this._env}/exportadados/crm-atendimento/${tipo}?uuid=${uuid}&temp=${isTemp}`, 
            exportacao, 
            this._headers)
        .then(
            res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw new Error('Erro ao salvar a exportação');
            }
        );
    }

    saveAtendimentoList(tipo, exportacaoAtendimento, column = 'datahora', order = 'desc', limit = 1000) {
        return this._http.post(
            `${this._env}/exportadados/crm-atendimento/list/${tipo}?column=${column}&order=${order}&limit=${limit}`, 
            exportacaoAtendimento, 
            this._headers
        )
        .then(
            res => {
                return res.body;
            }, 
            err => {
                this.verifyError(err);
                throw new Error('Erro ao salvar a exportação');
            }
        );
    }

    saveAgroVisita(exportacao, tipo, uuid) {
        return this._http.post(`${this._env}/exportadados/agrovisita/${tipo}?uuid=${uuid}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao salvar a exportação');
        });
    }

    saveAgroVisitaList(exportacao, tipo, column, order, ...params) {
        return this._http.post(`${this._env}/exportadados/agrovisitalist/${tipo}?column=${column}&order=${order}&param=${params}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Erro ao salvar a exportação');
        });
    }

    saveVendasperiodo(exportacao, tipo) {
        return this._http.post(`${this._env}/exportadados/vendasperiodo/${tipo}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    savePedido(exportacao, tipo, tipoPedidoExportacao, id) {
        return this._http.post(`${this._env}/exportadados/pedido/${tipo}?tipoPedidoExportacao=${tipoPedidoExportacao}&id=${id}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveOrcamento(exportacao, tipo, tipoPedidoExportacao, id) {
        return this._http.post(`${this._env}/exportadados/orcamento/${tipo}?tipoPedidoExportacao=${tipoPedidoExportacao}&id=${id}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    saveControleAparelhos(exportacao, tipo) {
        return this._http.post(`${this._env}/exportadados/controleaparelhos/${tipo}`, exportacao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}